<mat-toolbar id="app-header" class="header-background">

  <mat-toolbar-row style="justify-content: space-between; ">
    <div class="logo-ajust">
      <img
        src="/assets/img/header/serrapilheira-logo.svg"
        height="32px"
        alt="Logotipo Serrapilheira"

      />


  </div>
    <section class="header-right-menu">
      <span
        class="item visible_cursor"
        mat-raised-button
        (click)="projectInformationDialog()"><img src="/assets/img/header/infoHeader.svg" alt="" style="margin-top: 4px;"/>
      <span class="sobre-o-projeto">Sobre o Projeto</span>
    </span>

      <span class="item-line"></span>

      <span
        class="item visible_cursor"
        mat-button
        (click)="modalShortcutMenu()"
      >
        <img src="/assets/img/header/shortcutMenu-icon.svg" alt="" style="margin-top: 4px;"
      /></span>

      <!-- <span
        class="item visible_cursor"
        style="margin-left: 17px"
        mat-raised-button
        (click)="shareProject()"
      >
        <img src="/assets/img/share.svg" alt=""
      /></span> -->
    </section>
  </mat-toolbar-row>

  <mat-progress-bar  mode="indeterminate" color="#002FA7" *ngIf="loadingService.isLoading | async;"
  style="
  width: 100%;
  position: relative;
  z-index: 99;"
  >
  </mat-progress-bar>
</mat-toolbar>

